import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getStates } from "../../modules/utils";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.firstname)) {
    errors.firstname = "This field is required";
  }

  if (Validator.isEmpty(data.lastname)) {
    errors.lastname = "This field is required";
  }

  if (Validator.isEmpty(data.address1)) {
    errors.address1 = "This field is required";
  }

  if (Validator.isEmpty(data.city)) {
    errors.city = "This field is required";
  }
  if (Validator.isEmpty(data.state)) {
    errors.state = "This field is required";
  }
  if (Validator.isEmpty(data.country)) {
    errors.country = "This field is required";
  }
  if (Validator.isEmpty(data.zipcode)) {
    errors.zipcode = "This field is required";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class ShippingAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  defaultState = () => {
    return {
      firstname: "",
      lastname: "",
      address1: "",
      address2: "",
      country: "US",
      city: "",
      state: "",
      zipcode: "",
      errors: {},
      isLoading: false
    };
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.profile.userShipping) {
      this.setState({
        ...this.state,
        ...nextProps.auth.profile.userShipping,
        firstname : nextProps.auth.profile.firstname,
        lastname : nextProps.auth.profile.lastname,
      });
    }else{
      this.setState({
        firstname : nextProps.auth.profile.firstname,
        lastname : nextProps.auth.profile.lastname
      })
    }
  }

  _onChange = event => {
    console.log(event);
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);
    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  goBack = event => {
    event.preventDefault();
    this.props.back();
  };

  handleShipping = event => {
    event.preventDefault();
    const {
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    } = this.state;

    const shipping = {
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    };

    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true });
      this.props.handleShipping(shipping);
    }
  };

  render() {
    const {
      errors,
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    } = this.state;

    console.log(errors);
    return (
        <div className="col-lg-7 offset-lg-5 services_clip bg-gradient text-white">
          <div className="services_bg_pad">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="text-center services_boxes mt-3 rounded p-4">
                  <div className="services_content mt-3">
                    <h2 className="mb-0">SHIPPING ADDRESS</h2>
                    <p>Free shipping via First Class USPS in the US</p>
                    <p>For international shipping, please contact us by email: support@mightywifi.net</p>
                    <div style={{ clear: "both", height: "15px" }} />

                    <div className="row">
                      <div className="col-lg-3" />
                      <div className="col-lg-3">
                        <div className="form-group ">
                          <TextFieldGroup
                              field="firstname"
                              value={firstname}
                              error={errors.firstname}
                              onChange={this._onChange}
                              placeholder="First Name"
                              error={errors.firstname}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group ">
                          <TextFieldGroup
                              field="lastname"
                              value={lastname}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Last Name"
                              error={errors.lastname}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3" />
                    </div>

                    <div className="row">
                      <div className="col-lg-3" />
                      <div className="col-lg-6">
                        <div className="form-group ">
                          <TextFieldGroup
                              field="address1"
                              value={address1}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Address Line 1"
                              error={errors.address1}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3" />
                    </div>

                    <div className="row">
                      <div className="col-lg-3" />
                      <div className="col-lg-6">
                        <div className="form-group ">
                          <TextFieldGroup
                              field="address2"
                              value={address2}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Address Line 2"
                              error={errors.address2}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3" />
                    </div>

                    <div className="row">
                      <div className="col-lg-3" />
                      <div className="col-lg-6">
                        <div className="form-group ">
                          <TextFieldGroup
                              field="city"
                              value={city}
                              error={errors.city}
                              onChange={this._onChange}
                              placeholder="City"
                              error={errors.city}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3" />
                    </div>

                    <div className="row">
                      <div className="col-lg-3" />
                      <div className="col-lg-6">
                        <select
                            name="state"
                            onChange={this._onChange}
                            className="state form-control"
                            value={state}
                        >
                          <option value="">State</option>;
                          {getStates().map(function(state, index) {
                            return (
                                <option key={index} value={state.abbreviation}>
                                  {state.name}
                                </option>
                            );
                          })}
                        </select>

                        {errors.state && (
                            <span className="error-color">{errors.state}</span>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3" />
                      <div className="col-lg-3">
                        <TextFieldGroup
                            field="zipcode"
                            value={zipcode}
                            error={errors.zipcode}
                            onChange={this._onChange}
                            placeholder="ZIP code"
                            error={errors.zipcode}
                        />
                      </div>
                      <div className="col-lg-3">
                        <TextFieldGroup
                            field="country"
                            value={country}
                            error={errors.country}
                            onChange={this._onChange}
                            placeholder="US"
                            error={errors.country}
                            disabled
                        />
                      </div>
                      <div className="col-lg-3" />
                    </div>

                    <div style={{ clear: "both", height: "40px" }} />


                    <div className="container">

                      <a
                          href="javascript:void(0)"
                          onClick={this.goBack}
                          className="btn btn-outline-white"
                      >
                        Back
                      </a>

                      <a
                          style={{marginLeft:"22%"}}
                          href="javascript:void(0)"
                          onClick={this.handleShipping}
                          className="btn btn-outline-white"
                      >
                        CONTINUE
                      </a>
                    </div>
                    <div style={{ clear: "both", height: "100px" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export default connect(mapStateToProps)(ShippingAddress);



// WEBPACK FOOTER //
// ./src/pages/rechargeCheckout/ShippingAddress.js